export enum BaseFiltroPaginate {
  Limit = 10,
}
